import { c as _c } from "react/compiler-runtime";
import { ArrowBack } from "@opensea/ui-kit/icons";
import { Button } from "../Button";
export const ModalBackButton = t0 => {
  const $ = _c(3);
  const {
    onBack
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ArrowBack />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== onBack) {
    t2 = <Button className="absolute top-4 left-4 px-2" onClick={onBack} rounded={true} variant="ghost">{t1}</Button>;
    $[1] = onBack;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};